import fonts from "assets/stylesheets/modules/typography/font-families.module.scss";

export default fonts;
